import { render, staticRenderFns } from "./DocumentsTr.vue?vue&type=template&id=8eba6212&"
import script from "./DocumentsTr.vue?vue&type=script&lang=js&"
export * from "./DocumentsTr.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports